var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enterprise",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5558",
    "data-name": "Pfad 5558",
    d: "M9,9h2.25v4.5H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5559",
    "data-name": "Pfad 5559",
    d: "M9,15.75h2.25v4.5H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5560",
    "data-name": "Pfad 5560",
    d: "M15.75,9H18v4.5H15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5561",
    "data-name": "Pfad 5561",
    d: "M15.75,15.75H18v4.5H15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5562",
    "data-name": "Pfad 5562",
    d: "M9,22.5h2.25V27H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5563",
    "data-name": "Pfad 5563",
    d: "M15.75,22.5H18V27H15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5564",
    "data-name": "Pfad 5564",
    d: "M33.75,15.75A2.25,2.25,0,0,0,31.5,13.5H24.75v-9A2.25,2.25,0,0,0,22.5,2.25H4.5A2.25,2.25,0,0,0,2.25,4.5V33.75h31.5ZM4.5,4.5h18v27H4.5Zm20.25,27V15.75H31.5V31.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySettings);
export default __webpack_public_path__ + "static/media/company_settings.42293a3292353eda05d9796228edc958.svg";
export { ForwardRef as ReactComponent };